// src/services/dashboardService.js
import api from './api';

export const dashboardService = {
  // Get all PDFs for the current user
  getUserPdfs: async () => {
    try {
      const response = await api.get('/pdfs/user');
      return response.data.pdfs || [];
    } catch (error) {
      console.error('❌ Failed to fetch user PDFs:', error);
      
      // Handle rate limit errors
      if (error.status === 429) {
        return [];
      }
      
      throw error;
    }
  },

  // Get specific PDF by ID
  getPdfById: async (pdfId) => {
    try {
      const response = await api.get(`/pdfs/${pdfId}`);
      return response.data.pdf;
    } catch (error) {
      console.error('❌ Failed to fetch PDF:', error);
      
      // Handle rate limit errors
      if (error.status === 429) {
        return null;
      }
      
      throw error;
    }
  },

  deletePdf: async (pdfId) => {
    try {
      const response = await api.delete(`/pdfs/${pdfId}`);
      return response.data;
    } catch (error) {
      console.error('❌ PDF deletion failed:', error);
      
      // Handle rate limit errors
      if (error.status === 429) {
        return {
          success: false,
          error: 'rate_limit_exceeded',
          message: '⏳ Rate limit exceeded. Please wait and try again.'
        };
      }
      
      throw error;
    }
  },

  // Upload PDF
  uploadPdf: async (formData) => {
    try {
      const response = await api.post('/upload-pdf', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error('❌ PDF upload failed:', error);
      
      // Handle rate limit errors
      if (error.status === 429) {
        return {
          success: false,
          error: 'rate_limit_exceeded',
          message: '⏳ Rate limit exceeded. Please wait and try again.'
        };
      }
      
      throw error;
    }
  },

  // Get user PDF statistics
  getUserStats: async () => {
    try {
      const response = await api.get('/pdfs/user/stats');
      return response.data.stats;
    } catch (error) {
      console.error('❌ Failed to fetch user stats:', error);
      
      // Handle rate limit errors
      if (error.status === 429) {
        return null;
      }
      
      throw error;
    }
  },

  // Get PDFs by category
  getPdfsByCategory: async () => {
    try {
      const response = await api.get('/pdfs/user/categories');
      return response.data;
    } catch (error) {
      console.error('❌ Failed to fetch PDFs by category:', error);
      
      // Handle rate limit errors
      if (error.status === 429) {
        return {};
      }
      
      throw error;
    }
  }
};

export default dashboardService;